import { render } from "./Index2.vue?vue&type=template&id=2126f058&scoped=true&ts=true"
import script from "./Index2.vue?vue&type=script&lang=ts"
export * from "./Index2.vue?vue&type=script&lang=ts"

import "./Index2.vue?vue&type=style&index=0&id=2126f058&scoped=true&lang=css"
import "./Index2.vue?vue&type=style&index=1&id=2126f058&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2126f058"]])

export default __exports__